export default __webpack_public_path__ + "static/Theinhardt-Heavy-subset-0e8052a9f8b7d466cda0bf1a06c0d1b8.woff";